import { Suspense } from 'react'
import { Route, Routes } from 'react-router'

import LoginLayout from '@/components/layouts/LoginLayout'

import NotFoundPage from '@/pages/404'
import EmailVerificationPage from '@/pages/email-verification'
import LandingPage from '@/pages/landing'
import LodgeAComplaintPage from '@/pages/lodge-a-complaint'
import LoginPage from '@/pages/login'
import OTPVerificationPage from '@/pages/otp-verification'
import PhoneOtpPage from '@/pages/phone-otp'
import VerificationStatusPage from '@/pages/verification-status'

const Router = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<LandingPage />} path="/" />
        <Route
          element={
            <LoginLayout>
              <LoginPage />
            </LoginLayout>
          }
          path="/login"
        />
        <Route
          element={
            <LoginLayout>
              <PhoneOtpPage />
            </LoginLayout>
          }
          path="/otp"
        />
        <Route element={<EmailVerificationPage />} path="/verify-email" />
        <Route element={<OTPVerificationPage />} path="/verify-otp" />
        <Route element={<VerificationStatusPage />} path="/verification-status" />
        <Route element={<LodgeAComplaintPage />} path="/lodge-a-complaint" />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </Suspense>
  )
}

export default Router
